import React from 'react';
import { useNavigate } from 'react-router-dom';

const p =
  'text-[14px] text-[#8c8c8c] leading-[1.6]';
const h2 = 'text-[18px] font-medium text-black mb-3 mt-8 first:mt-0';
const block = 'space-y-3';
const sub = 'font-medium text-black';

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#FAF7F2]">
      <div className="bg-[#FAF7F2]  md:px-[120px] p-[20px] md:pt-[60px] md:pb-[20px] gap-[16px] flex items-center">
        <button 
          type="button"
          onClick={() => navigate(-1)}
          className="hover:bg-gray-100 rounded-full"
          aria-label="Go back"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <g clipPath="url(#clip0_terms_back)">
              <path d="M5 12H19" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 18" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 12L11 6" stroke="black" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_terms_back">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </button>
        <h1 className="text-[20px] font-medium text-black tracking-[-1px]">
          Terms and Conditions of Use
        </h1>
      </div>

      <div className=" md:px-[120px] p-[20px] md:py-[20px] flex flex-col gap-[8px] pb-10">
        <div className="bg-white rounded-[16px] p-[24px] shadow-sm">
          <p className="text-[12px] uppercase tracking-wide text-[#8c8c8c] mb-1">BookForPaws Platform</p>
          <p className="text-[14px] text-[#8c8c8c] mb-6">Last updated: 7 April 2026</p>

          <div className="space-y-2">
            <p className={p}>
              These Terms and Conditions (&quot;Terms&quot;) govern your access to and use of the website, mobile
              application and related services operated under the brand BookForPaws (&quot;BFP&quot;), owned and
              operated by Joey &amp; Chandler Tech Ventures LLP, having its registered office at 123 Pet Paradise
              Street, Mumbai, Maharashtra 400001, India (hereinafter referred to as the &quot;Platform&quot;,
              &quot;BFP&quot;, &quot;we&quot;, &quot;us&quot;, or &quot;our&quot;).
            </p>
            <p className={p}>
              For the purpose of these Terms, the term &quot;Vendor&quot; shall mean any individual, company,
              organisation, service provider, host, event organiser, accommodation provider, pet service provider,
              or other business entity that lists, offers, promotes, or provides services, events, accommodations,
              products, or related offerings on the Platform for booking or access by users.
            </p>
            <p className={p}>
              By accessing, browsing, registering on or using the Platform, you acknowledge that you have read,
              understood and agree to be bound by these Terms and all policies referenced herein.
            </p>
            <p className={p}>
              If you do not agree with these Terms, you must immediately discontinue use of the Platform.
            </p>
            <p className={p}>
              These Terms constitute a legally binding agreement between you (&quot;User&quot;) and the Platform.
            </p>
          </div>

          <div className="mt-6 space-y-8">
            <section>
              <h2 className={h2}>1. ABOUT THE PLATFORM</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>1.1. </span>
                  BookForPaws is an online digital platform designed to help pet owners discover and access
                  pet-friendly experiences and services offered by independent third-party vendors.
                </p>
                <p className={p}>
                  <span className={sub}>1.2. </span>
                  The Platform enables Users to search for and book services, including but not limited to,
                  pet-friendly stays and accommodations, pet training programs, pet behavioural workshops, pet
                  socialisation events, pet competitions and shows, seminars, meet-ups and community gatherings,
                  pet travel experiences, other pet-related programs and services.
                </p>
                <p className={p}>
                  <span className={sub}>1.3. </span>
                  The Platform acts as a technology marketplace that facilitates listing, discovery, booking and
                  payment processing for such services.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>2. ROLE OF BOOKFORPAWS</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>2.1. </span>
                  BookForPaws operates solely as an online technology intermediary connecting users with
                  independent third-party vendors.
                </p>
                <p className={p}>
                  <span className={sub}>2.2. </span>
                  The Platform does not: own, manage, operate, supervise, control, inspect any accommodation,
                  event, training program or other service listed on the Platform.
                </p>
                <p className={p}>
                  <span className={sub}>2.3. </span>
                  All services are offered and provided directly by independent vendors.
                </p>
                <p className={p}>
                  <span className={sub}>2.4. </span>
                  Accordingly, the Vendors are solely responsible for organising and delivering their services. The
                  Platform does not guarantee the quality, safety, legality, availability or suitability of vendor
                  services. Any booking made through the Platform creates a direct contractual relationship between
                  the User and the Vendor providing the service.
                </p>
                <p className={p}>
                  <span className={sub}>2.5. </span>
                  The Platform&apos;s role is limited to facilitating technology services that enable discovery and
                  booking.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>3. USER ELIGIBILITY</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>3.1. </span>
                  To use the Platform, a user must be at least 18 years of age and must possess the legal capacity to
                  enter into a binding and enforceable contract under applicable law. By accessing or using the
                  Platform, the user represents and warrants that the information provided during registration or
                  while using the services is true, accurate, complete, and not misleading. The user further agrees
                  to comply with all applicable laws, rules, and regulations while accessing or using the Platform
                  and the services made available through it.
                </p>
                <p className={p}>
                  <span className={sub}>3.2. </span>
                  In the event a user makes a booking or accesses the services on behalf of any other person, the
                  user represents and confirms that he or she has the necessary authority and consent from such
                  person(s) to do so. In such cases, the user agrees that these Terms shall apply to the booking and
                  the services availed on behalf of such person(s), and the user shall be responsible for ensuring
                  that such person(s) comply with these Terms and all applicable policies of the Platform.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>4. USER ACCOUNT</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>4.1. </span>
                  Certain features and services available on the Platform may require the user to register and create
                  a user account. For the purpose of such registration, the user may be required to provide certain
                  personal and contact details and create login credentials. The user agrees that all information
                  provided during the registration process, and thereafter while using the Platform, shall be true,
                  accurate, complete, and up to date. The user further undertakes to promptly update any information
                  that may become inaccurate or incomplete.
                </p>
                <p className={p}>
                  <span className={sub}>4.2. </span>
                  The user shall be solely responsible for maintaining the confidentiality and security of their
                  login credentials, including their username, password, and any other authentication information
                  associated with the account. The user agrees not to share, transfer, or disclose such credentials
                  to any third party. All activities carried out through the user&apos;s account shall be deemed to
                  have been carried out by the user, and the user shall be fully responsible and liable for any
                  actions, transactions, or bookings made through their account.
                </p>
                <p className={p}>
                  <span className={sub}>4.3. </span>
                  The user agrees that they shall not impersonate any other individual or entity, misrepresent their
                  identity, or provide false or misleading information while creating or using an account on the
                  Platform. The user shall also not create multiple accounts for fraudulent, deceptive, or abusive
                  purposes, nor shall the user attempt to access, use, or interfere with another user&apos;s account
                  without proper authorization.
                </p>
                <p className={p}>
                  <span className={sub}>4.4. </span>
                  The Platform reserves the right, at its sole discretion and without prior notice, to suspend,
                  restrict, or terminate any user account that is found to be in violation of these Terms, or where
                  the Platform reasonably believes that the account has been used for unlawful, fraudulent, or
                  unauthorized activities. In such cases, the Platform may also take any additional action deemed
                  necessary to protect the integrity, security, and proper functioning of the Platform and its
                  services.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>5. PET INFORMATION AND DISCLOSURE</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>5.1. </span>
                  Users who bring pets to events, accommodations, or services booked through the Platform are
                  required to provide complete and accurate information regarding their pets at the time of
                  booking or as otherwise requested by the Platform or the relevant vendor. Such information may
                  include, but is not limited to, the pet&apos;s breed or species, approximate size or weight,
                  temperament, vaccination status, and any relevant behavioural history that may be necessary to
                  ensure the safety and comfort of other guests, animals, and service providers.
                </p>
                <p className={p}>
                  <span className={sub}>5.2. </span>
                  By providing such information, users represent and confirm that the details furnished about their
                  pets are true, accurate, and not misleading. Users further confirm that their pets are in good
                  health, have received all required vaccinations in accordance with applicable veterinary standards
                  and local regulations, and are free from contagious diseases. Users also undertake that their pets
                  will be properly supervised and kept under control at all times while attending events, staying at
                  accommodations, or using any services arranged through the Platform. Users acknowledge that
                  individual vendors, hosts, or service providers listed on the Platform may impose additional rules
                  or policies relating to pets. Such policies may include requirements regarding vaccination records,
                  breed or species restrictions, size limitations, behavioural standards, leash or containment
                  requirements, and other safety measures. Users agree to review and comply with all such
                  vendor-specific policies and acknowledge that failure to do so may result in refusal of service,
                  cancellation of the booking, or removal from the premises without any liability on the part of the
                  Platform.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>6. BOOKING PROCESS</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>6.1. </span>
                  Users may browse, review, and select services, events, accommodations, or other offerings listed on
                  the Platform. The listings may contain descriptions, pricing details, availability information,
                  applicable policies, and any specific requirements imposed by the respective vendors or service
                  providers. Users are responsible for carefully reviewing all listing details, policies, and
                  applicable conditions before proceeding with a booking.
                </p>
                <p className={p}>
                  <span className={sub}>6.2. </span>
                  The booking process generally involves the following steps. First, the user selects the desired
                  service, event, or accommodation available on the Platform. Second, the user reviews the listing
                  information, including the description of services, pricing, availability, vendor policies,
                  pet-related requirements, cancellation terms, and any other conditions applicable to the booking.
                  Third, where payment through the Platform is required, the user proceeds to complete the booking
                  request by providing the necessary booking details and making payment through the payment methods
                  made available on the Platform. Fourth, upon completion of the booking request, the user may receive
                  a booking acknowledgment or confirmation notification through the Platform or via registered
                  communication channels.
                </p>
                <p className={p}>
                  <span className={sub}>6.3. </span>
                  A booking shall be deemed confirmed only after the required payment has been successfully processed
                  and, where applicable, the vendor or service provider has accepted or confirmed the booking
                  request. In certain cases, vendors may review the booking request before confirming the
                  reservation, particularly where specific requirements, availability checks, or pet-related
                  considerations apply. The Platform acts as a facilitation and technology service that enables users
                  to discover and request services from independent vendors. Accordingly, the Platform does not
                  guarantee that every booking request submitted by a user will be accepted or confirmed. Vendors
                  retain the right to accept or decline booking requests in accordance with their availability,
                  policies, or other reasonable considerations. In the event a booking request is not accepted or
                  cannot be fulfilled, the user will be notified accordingly, and any payment made through the Platform
                  shall be handled in accordance with the applicable payment and refund policies.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>7. PRICING AND PAYMENTS</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>7.1. </span>
                  The prices displayed on the Platform for services, events, accommodations, or other offerings are
                  determined and set by the respective vendors or service providers. While the Platform may display
                  such prices for the convenience of users, the vendors remain responsible for the accuracy of the
                  pricing, inclusions, and any additional charges applicable to their listings.
                </p>
                <p className={p}>
                  <span className={sub}>7.2. </span>
                  The total amount payable by the user at the time of booking may include several components. These may
                  include the service charges or fees determined by the vendor, any applicable platform service or
                  convenience fees charged for facilitating the booking, applicable government taxes, and payment
                  gateway or transaction processing charges, where applicable. The final amount payable will generally
                  be displayed to the user prior to completing the payment process.
                </p>
                <p className={p}>
                  <span className={sub}>7.3. </span>
                  Payments made through the Platform may be processed through third-party payment gateway service
                  providers integrated with the Platform. By making a payment through the Platform, the user
                  acknowledges and agrees that the transaction may be subject to the terms, conditions, and
                  policies of such third-party payment service providers. The Platform itself does not directly process
                  or store sensitive payment information such as credit card or banking details.
                </p>
                <p className={p}>
                  <span className={sub}>7.4. </span>
                  Where payments are collected through the Platform on behalf of vendors, the Platform may deduct its
                  applicable service fees, transaction charges, taxes, or other agreed charges before remitting the
                  remaining amount to the relevant vendor or service provider in accordance with its internal
                  settlement processes and applicable agreements with vendors.
                </p>
                <p className={p}>
                  <span className={sub}>7.5. </span>
                  The Platform shall not be responsible or liable for any failure, delay, interruption, or error in
                  payment processing that arises due to technical issues, system failures, or operational delays on
                  the part of third-party payment gateway providers, banks, or financial institutions involved in the
                  transaction. Users are encouraged to contact the relevant payment service provider or financial
                  institution in case of payment-related issues arising from such third-party services.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>8. CANCELLATION AND REFUND POLICY</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>8.1. </span>
                  Cancellation and refund policies applicable to bookings made through the Platform may vary
                  depending on the nature of the service, event, or accommodation booked and the policies determined by
                  the respective vendor or service provider. Since vendors operate independently and may follow
                  different cancellation rules, users are required to carefully review the cancellation and refund
                  policy specified in the relevant listing before confirming any booking on the Platform. By
                  proceeding with a booking, the user acknowledges and agrees to be bound by the cancellation and
                  refund terms applicable to that particular service.
                </p>
                <p className={`${p} font-medium text-black`}>8.2. User cancellation</p>
                <p className={p}>
                  <span className={sub}>8.2.1. </span>
                  If a user chooses to cancel a confirmed booking, the refund, if any, shall be governed strictly by
                  the cancellation policy specified by the vendor in the relevant listing. Depending on the vendor&apos;s
                  terms and the timing of the cancellation, the user may be eligible for a full refund, a partial
                  refund, or may not be entitled to any refund at all. Certain vendors may allow cancellations only
                  within a specific time frame prior to the scheduled service or event, after which cancellation
                  charges or full forfeiture of the booking amount may apply. Users are therefore advised to review
                  these conditions carefully before completing a booking.
                </p>
                <p className={`${p} font-medium text-black`}>8.3. Vendor cancellation</p>
                <p className={p}>
                  <span className={sub}>8.3.1. </span>
                  In the event that a vendor cancels a confirmed booking for any reason, the vendor shall be
                  responsible for refunding the applicable booking amount to the user in accordance with the
                  vendor&apos;s cancellation policy or applicable law. Where the booking payment was made through the
                  Platform, the Platform may facilitate the refund process on behalf of the vendor to the extent
                  technically possible. However, the obligation to honour the booking or provide refunds arising from
                  vendor cancellations remains the responsibility of the vendor.
                </p>
                <p className={`${p} font-medium text-black`}>8.4. Event cancellations</p>
                <p className={p}>
                  <span className={sub}>8.4.1. </span>
                  If an event listed on the Platform is cancelled by the organiser or the vendor, refunds to users
                  shall be processed in accordance with the cancellation or refund policy communicated by the
                  organiser or vendor for that particular event. Where payments were processed through the Platform,
                  the Platform may assist in facilitating the refund transaction between the vendor and the user.
                  However, the Platform does not assume financial liability for event cancellations or for any losses
                  arising from such cancellations.
                </p>
                <p className={`${p} font-medium text-black`}>8.5. Accommodation cancellations</p>
                <p className={p}>
                  Bookings relating to accommodations listed on the Platform may be subject to specific cancellation
                  timelines and conditions set by the vendor or host. These policies may vary depending on factors
                  such as the date of cancellation, the check-in date, peak season policies, or minimum notice
                  requirements. Users must review the accommodation&apos;s cancellation terms before confirming the
                  booking, as eligibility for refunds may depend on compliance with the vendor&apos;s specified
                  timelines.
                </p>
                <p className={`${p} font-medium text-black`}>8.6. No-show</p>
                <p className={p}>
                  <span className={sub}>8.6.1. </span>
                  If a user fails to attend a scheduled event, service, or accommodation booking without cancelling
                  the booking in accordance with the applicable vendor cancellation policy, the booking may be treated
                  as a &quot;no-show.&quot; In such cases, the vendor may be entitled to retain the entire booking
                  amount, and the user may not be eligible for any refund.
                </p>
                <p className={`${p} font-medium text-black`}>8.7. Platform service fees</p>
                <p className={p}>
                  <span className={sub}>8.7.1. </span>
                  In certain cases, the Platform may charge a service fee, convenience fee, or facilitation fee for
                  enabling the booking. Unless otherwise required by applicable law, such platform service fees may be
                  non-refundable even if the vendor issues a refund for the underlying service amount. Any such
                  charges, where applicable, will generally be displayed to the user prior to completing the booking.
                </p>
                <p className={`${p} font-medium text-black`}>8.8. Refund processing</p>
                <p className={p}>
                  <span className={sub}>8.8.1. </span>
                  Where a user is eligible for a refund in accordance with the applicable cancellation policy, the
                  refund will generally be processed through the same payment method that was used to complete the
                  original transaction, wherever possible. Refund amounts may be subject to deductions for payment
                  gateway charges, transaction fees, or other applicable deductions as specified in the vendor&apos;s
                  policy or permitted by law. The time required for the refund to reflect in the user&apos;s account may
                  vary depending on the payment gateway provider, banking processes, and the user&apos;s financial
                  institution. As such, refund timelines may differ and are subject to the processing timelines of
                  the relevant payment service providers and banks involved in the transaction.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>9. USER RESPONSIBILITIES</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>9.1. </span>
                  Users agree to conduct themselves in a responsible and respectful manner while attending events,
                  staying at accommodations, or using any services booked through the Platform. Users shall comply
                  with all applicable rules, policies, safety guidelines, and instructions communicated by the
                  relevant vendors, hosts, organisers, or service providers in relation to the services being
                  provided.
                </p>
                <p className={p}>
                  <span className={sub}>9.2. </span>
                  Users who bring pets to events, accommodations, or other services booked through the Platform must
                  ensure that their pets are properly supervised and remain under their control at all times. Users
                  shall take reasonable precautions to ensure that their pets behave appropriately and do not pose
                  any risk to other guests, animals, staff members, or property present at the venue.
                </p>
                <p className={p}>
                  <span className={sub}>9.3. </span>
                  Users further agree to ensure that their pets do not cause injury, harm, disturbance, nuisance, or
                  inconvenience to other persons or animals, and do not cause damage to the premises, facilities,
                  furniture, or any other property belonging to vendors, hosts, or third parties.
                </p>
                <p className={p}>
                  <span className={sub}>9.4. </span>
                  The user shall be solely responsible and liable for any loss, injury, damage, or expenses arising
                  from the conduct of the user or their pet during the course of the event, stay, or service. In the
                  event that any damage to property or injury to persons or animals occurs as a result of the actions
                  or negligence of the user or their pet, the user agrees to compensate the affected vendor, host, or
                  third party for such damage or loss in accordance with applicable law and the policies of the
                  relevant service provider.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>10. REVIEWS AND RATINGS</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>10.1. </span>
                  Users may have the option to submit reviews, ratings, or feedback in relation to services, events,
                  or accommodations booked through the Platform after the completion of such services. These reviews
                  are intended to provide genuine feedback based on the user&apos;s personal experience and to assist
                  other users in making informed decisions when selecting services through the Platform.
                </p>
                <p className={p}>
                  <span className={sub}>10.2. </span>
                  Users agree that any review, rating, comment, or feedback submitted on the Platform shall be
                  truthful, fair, and based on their actual experience with the vendor or service provider. Users
                  shall not post reviews that are false, misleading, abusive, offensive, defamatory, threatening, or
                  otherwise harmful to any person or entity. Reviews must also not contain unlawful content, personal
                  attacks, promotional material, or any content that violates applicable laws or the policies of the
                  Platform.
                </p>
                <p className={p}>
                  <span className={sub}>10.3. </span>
                  The Platform reserves the right, at its sole discretion, to monitor, moderate, edit, or remove any
                  reviews, ratings, or feedback that it determines to be in violation of these Terms, the Platform&apos;s
                  policies, or applicable law. The Platform may also take appropriate action, including restricting or
                  suspending user accounts, where reviews are found to be abusive, fraudulent, or intended to
                  manipulate the reputation of vendors or other users.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>11. USER GENERATED CONTENT</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>11.1. </span>
                  Users may have the ability to upload, post, or submit content on the Platform, including but not
                  limited to reviews, comments, feedback, photographs, or other information relating to services,
                  events, accommodations, or experiences booked through the Platform. Users are responsible for
                  ensuring that any content submitted by them is lawful, accurate, and does not infringe upon the
                  rights of any third party, including intellectual property rights, privacy rights, or other legal
                  rights.
                </p>
                <p className={p}>
                  <span className={sub}>11.2. </span>
                  By submitting, uploading, or posting such content on the Platform, the user grants the Platform a
                  non-exclusive, worldwide, royalty-free licence to use, reproduce, display, publish, distribute, and
                  otherwise make such content available for the purpose of operating, maintaining, improving, and
                  promoting the Platform and its services. This licence includes the right for the Platform to display
                  the content on its website, mobile applications, promotional materials, social media channels, and
                  other communication or marketing platforms associated with the Platform.
                </p>
                <p className={p}>
                  <span className={sub}>11.3. </span>
                  The user acknowledges that the licence granted to the Platform is limited to purposes related to the
                  functioning, promotion, and improvement of the Platform and does not transfer ownership of the
                  content from the user to the Platform. The user retains ownership of the content submitted but
                  agrees that the Platform may use such content in accordance with the rights granted under these
                  Terms.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>12. PET SAFETY DISCLAIMER</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>12.1. </span>
                  Users acknowledge and understand that animals may behave unpredictably and that interactions between
                  pets, other animals, and individuals may involve certain inherent risks. Such risks may include,
                  but are not limited to, unexpected behaviour by pets, conflicts between animals, accidental
                  injuries, or damage to property that may occur during events, activities, or stays where pets are
                  present. By choosing to participate in events, accommodations, or services involving pets through the
                  Platform, users voluntarily accept and assume these inherent risks. Users are responsible for
                  exercising reasonable care, supervision, and control over their pets and for taking appropriate
                  precautions to ensure the safety of their pets, other animals, and individuals present at the venue.
                </p>
                <p className={p}>
                  <span className={sub}>12.2. </span>
                  To the fullest extent permitted under applicable law, the Platform shall not be responsible or
                  liable for any injuries sustained by pets, any injuries caused by pets to other animals or
                  individuals, any behavioural incidents involving pets, or any damage to property caused by pets
                  during events, activities, or stays arranged through the Platform. Users further acknowledge that
                  participation in such events or stays is undertaken at their own risk and discretion, and that the
                  Platform functions only as a facilitation service connecting users with independent vendors,
                  organisers, or hosts.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>13. INTELLECTUAL PROPERTY</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>13.1. </span>
                  All intellectual property rights in and relating to the Platform, including but not limited to its
                  trademarks, service marks, logos, software, technology, design, layout, text, graphics, images,
                  databases, and other content available on the Platform, are owned by or validly licensed to the
                  Platform and are protected under applicable intellectual property laws.
                </p>
                <p className={p}>
                  <span className={sub}>13.2. </span>
                  Users are permitted to access and use the Platform and its content solely for personal and lawful
                  purposes in connection with the services offered through the Platform. Except as expressly permitted
                  under these Terms or with the prior written consent of the Platform, users shall not copy, reproduce,
                  modify, distribute, transmit, display, publish, create derivative works from, or otherwise exploit
                  any part of the Platform or its content for commercial or non-commercial purposes.
                </p>
                <p className={p}>
                  <span className={sub}>13.3. </span>
                  Any unauthorised use of the Platform&apos;s intellectual property may constitute a violation of
                  applicable intellectual property laws and may result in appropriate legal action being taken against
                  the user.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>14. PROHIBITED USE</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>14.1. </span>
                  Users agree to use the Platform only for lawful purposes and in a manner that complies with these
                  Terms, applicable laws, and the rights of other users and third parties. While accessing or using
                  the Platform, users shall not engage in any activity that is illegal, harmful, deceptive, or
                  intended to misuse the services provided through the Platform. Users shall not upload, submit, or
                  provide any false, misleading, or inaccurate information while creating an account, making bookings,
                  posting content, or otherwise using the Platform. Users are responsible for ensuring that the
                  information provided by them is truthful and does not misrepresent their identity, intentions, or
                  the details of any booking or transaction. Users shall also not attempt to gain unauthorised access
                  to the Platform, its systems, servers, databases, or networks. Any attempt to hack, disrupt, damage,
                  reverse engineer, interfere with the functioning of the Platform, or circumvent security measures
                  implemented by the Platform is strictly prohibited.
                </p>
                <p className={p}>
                  <span className={sub}>14.2. </span>
                  Further, users shall not engage in any fraudulent, deceptive, or abusive activities while using the
                  Platform. This includes activities such as creating fraudulent accounts, attempting to manipulate
                  bookings or reviews, misusing payment systems, or using the Platform in a manner intended to deceive
                  vendors, other users, or the Platform itself. The Platform reserves the right, at its sole discretion
                  and without prior notice, to suspend, restrict, or terminate the accounts of users found to be
                  engaging in any of the prohibited activities described above. The Platform may also take any
                  additional action it considers necessary to protect its services, other users, and vendors, including
                  reporting such activities to the relevant authorities where required.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>15. LIMITATION OF LIABILITY</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>15.1. </span>
                  To the fullest extent permitted under applicable law, the Platform shall not be liable for any loss,
                  damage, injury, or claim arising out of or in connection with services provided by vendors or the use
                  of services booked through the Platform. Vendors listed on the Platform operate independently, and
                  the Platform acts only as an intermediary that facilitates discovery of services and the booking
                  process between users and vendors. Accordingly, the Platform shall not be responsible or liable for
                  any failure, delay, deficiency, or non-performance of services by vendors, including but not limited
                  to cancellations, service quality issues, or failure to deliver the services as described in the
                  listing. The Platform shall also not be liable for any personal injury, harm, or illness suffered by
                  pets, users, participants, or any third parties during events, activities, or stays arranged
                  through vendors listed on the Platform.
                </p>
                <p className={p}>
                  <span className={sub}>15.2. </span>
                  Further, the Platform shall not be responsible for any loss or damage to property belonging to
                  users, vendors, or third parties that may occur in connection with events, accommodations, or
                  services booked through the Platform. Any disputes, disagreements, or claims arising between users
                  and vendors, including those relating to service quality, refunds, damages, or conduct during events
                  or stays, shall be resolved directly between the concerned parties. In no event shall the Platform be
                  liable for any indirect, incidental, special, or consequential losses or damages, including loss of
                  profits, loss of opportunity, loss of data, or reputational harm, arising out of or related to the use
                  of the Platform or services booked through it. Users acknowledge and agree that the Platform&apos;s role
                  is limited to providing technology services that facilitate listings, discovery, and booking of
                  services offered by independent vendors, and that the Platform does not itself provide or control
                  the underlying services offered by such vendors.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>16. INDEMNITY</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>16.1. </span>
                  Users agree to indemnify, defend, and hold harmless the Platform, its owners, directors, officers,
                  employees, agents, and affiliates from and against any and all claims, demands, actions,
                  proceedings, liabilities, losses, damages, costs, and expenses, including reasonable legal fees,
                  arising out of or in connection with the user&apos;s use or misuse of the Platform. Such indemnification
                  shall include, without limitation, any claims or liabilities arising from the user&apos;s violation or
                  breach of these Terms, any misuse of the Platform or its services, the submission of false or
                  misleading information, or any unlawful or negligent conduct by the user while accessing or using the
                  Platform. Users shall also be responsible for any claims, damages, or losses arising from the
                  actions or behaviour of their pets during events, activities, accommodations, or services booked
                  through the Platform. This includes situations where pets cause injury to persons or other animals,
                  create disturbances, or cause damage to property belonging to vendors, hosts, participants, or
                  other third parties. Further, users agree to indemnify and hold the Platform harmless from any
                  claims, disputes, or legal proceedings arising between the user and vendors or service providers
                  listed on the Platform, including disputes relating to services, bookings, cancellations, payments,
                  or conduct during events or stays. The Platform shall not be responsible for resolving such disputes
                  beyond providing reasonable facilitation where possible.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>17. ACCOUNT SUSPENSION</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>17.1. </span>
                  The Platform reserves the right, at its sole discretion and without prior notice, to suspend,
                  restrict, or permanently terminate a user&apos;s account and access to the Platform in the event that
                  the user is found to have violated or breached any provision of these Terms, engaged in fraudulent,
                  deceptive, or unlawful activities, or acted in a manner that may compromise the safety, security,
                  integrity, or lawful operation of the Platform, its users, vendors, or third parties. This includes,
                  without limitation, activities such as providing false or misleading information, misuse of the
                  Platform&apos;s services, manipulation of bookings or reviews, unauthorised access to accounts or
                  systems, or any conduct that exposes the Platform or its users to legal, financial, or reputational
                  risks. In such cases, the Platform shall have the right to immediately suspend or terminate the
                  user&apos;s account, restrict access to services, cancel pending bookings where necessary, and take any
                  other action deemed appropriate to protect the Platform and its community, without incurring any
                  liability to the user.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>18. FORCE MAJEURE</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>18.1. </span>
                  The Platform shall not be liable for any delay, interruption, or failure in the performance of its
                  obligations or services where such delay or failure arises from events or circumstances beyond its
                  reasonable control. Such events may include, without limitation, natural disasters, acts of God,
                  floods, earthquakes, fires, pandemics, epidemics, government orders or restrictions, regulatory
                  changes, strikes or labour disputes, power outages, failures of telecommunications or internet
                  services, technical system failures, or any other unforeseen events that prevent or hinder the normal
                  operation of the Platform. During the occurrence of such events, the Platform shall be entitled to
                  suspend or limit its services to the extent reasonably necessary and shall not be held responsible for
                  any losses, damages, or inconvenience arising from such delays or disruptions.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>19. MODIFICATION OF TERMS</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>19.1. </span>
                  The Platform reserves the right, at its sole discretion, to modify, amend, or update these Terms from
                  time to time in order to reflect changes in its services, operational practices, legal
                  requirements, or for any other legitimate business reasons. Any revised or updated version of these
                  Terms will be published on the Platform and will become effective from the date of such publication
                  or from such date as may be specified in the updated Terms.
                </p>
                <p className={p}>
                  <span className={sub}>19.2. </span>
                  Users are encouraged to periodically review the Terms to remain informed of any changes. Continued
                  access to or use of the Platform after the publication of updated Terms shall constitute the user&apos;s
                  acceptance of and agreement to be bound by the revised Terms. If a user does not agree with the
                  modified Terms, the user should discontinue use of the Platform.
                </p>
              </div>
            </section>

            <section>
              <h2 className={h2}>20. GOVERNING LAW AND JURISDICTION</h2>
              <div className={block}>
                <p className={p}>
                  <span className={sub}>20.1. </span>
                  These Terms shall be governed by and construed in accordance with the laws of India, without regard
                  to its conflict of law principles. All matters relating to the interpretation, validity, performance,
                  or enforcement of these Terms shall be determined in accordance with the applicable laws in force
                  in India.
                </p>
                <p className={p}>
                  <span className={sub}>20.2. </span>
                  Any disputes, claims, or differences arising out of or in connection with these Terms, the use of
                  the Platform, or any services accessed through the Platform shall be subject to the exclusive
                  jurisdiction of the competent courts located in Mumbai, Maharashtra. The parties agree to submit to
                  the jurisdiction of such courts for the resolution of any such disputes.
                </p>
          </div>
            </section>

            <section>
              <h2 className={h2}>21. CONTACT INFORMATION</h2>
              <div className={`${block} mt-3`}>
                <p className={p}>
                  <span className={sub}>21.1. </span>
                  BookForPaws
                  <br />
                  Joey &amp; Chandler Tech Ventures LLP
                </p>
                <div className="mt-4 p-4 bg-[#FF5E4C] bg-opacity-10 border border-[#FF5E4C] border-opacity-20 rounded-lg">
                  <p className={`${p} mb-2`}>
                    <strong className="text-black">Email:</strong>{' '}
                    <a href="mailto:help@bookforpaws.com" className="text-[#FF5E4C] underline underline-offset-2">
                      help@bookforpaws.com
                    </a>
                  </p>
                  <p className={p}>
                    <strong className="text-black"> Mumbai Office:</strong> WEWORK, NESCO, Building 4, North Wing, NESCO IT Park, Western Express Hwy, NESCO, Goregaon East, Mumbai, Maharashtra 400063
                  </p>
                </div>
            </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Terms; 
